import api from '@/services/utils/apiInstance'
import { formatDateToApi } from '@/utils/dateUtils'

class RentalFileService {
  async createRentalFile(data) {
    const response = await api.post('/admin/rental-file/create', data)
    return response.data
  }

  async getRentalFileSummary(rentalFileId) {
    const response = await api.get('/admin/rental-file/summary-detail/' + rentalFileId)
    return response.data
  }

  async getRentalFileSummaryByBoomerangId(rentalFileBoomerangId) {
    const response = await api.get(
      '/admin/rental-file/summary-detail/by-boomerang-id/' + rentalFileBoomerangId
    )
    return response.data
  }

  async getRentalFileDetail(rentalFileId) {
    const response = await api.get('/admin/rental-file/detail/' + rentalFileId)
    return response.data
  }

  async getPaginatedRentalFileCommentList(rental_file_id, page, limit) {
    const url =
      '/admin/rental-file/comment/list/' + rental_file_id + '?page=' + page + '&limit=' + limit
    const response = await api.get(url)
    return response.data
  }

  async createRentalFileComment(data) {
    const response = await api.post('/admin/rental-file/comment/create', data)
    return response.data
  }

  async getAttachmentFileList(rentalFileId) {
    const response = await api.get('/admin/rental-file/attachment/list/' + rentalFileId)
    return response.data
  }

  async uploadAttachmentFile(data) {
    const response = await api.put(
      '/admin/rental-file/attachment/upload-additional-attachment',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  }

  async getRentalFileByRepairFileId(repairFileId) {
    const response = await api.get('/admin/rental-file/by-repair-file/' + repairFileId)
    return response.data
  }

  async getRentalFileDeliveryAddress(rentalFileId) {
    const response = await api.get(
      '/admin/rental-file/detail/' + rentalFileId + '/delivery-address'
    )
    return response.data
  }

  async updateRentalFileStatus(rentalFileId, date) {
    let data = {
      rental_file_id: rentalFileId,
      real_date: formatDateToApi(date)
    }

    const response = await api.put('/admin/rental-file/status-update', data)
    return response.data
  }

  async updateRentalFileStatusToTransporterGo(rentalFileId, transporterType, trackingNumber, date) {
    let data = {
      rental_file_id: rentalFileId,
      real_date: formatDateToApi(date),
      transporter_type: transporterType,
      tracking_number: trackingNumber
    }

    const response = await api.put('/admin/rental-file/status-update/transport-go', data)
    return response.data
  }

  async updateRentalFileStatusToClientInformed(rentalFileId, date) {
    let data = {
      rental_file_id: rentalFileId,
      real_date: formatDateToApi(date)
    }

    const response = await api.put('/admin/rental-file/status-update/client-informed', data)
    return response.data
  }

  async updateRentalFileStatusToStoreReceipt(rentalFileId, date, qr_code_token, forcePassStatus) {
    let data = {
      rental_file_id: rentalFileId,
      real_date: formatDateToApi(date),
      qr_code_token: qr_code_token,
      force_pass_status: forcePassStatus
    }

    const response = await api.put('/admin/rental-file/status-update/store-receipt', data)
    return response.data
  }

  async getQRCodeToken(rentalFileId) {
    const response = await api.get('/admin/rental-file/qr-code-token/' + rentalFileId)
    return response.data
  }

  async validateRentalFileQrCodeToken(token) {
    const data = {
      qr_code_token: token
    }
    const response = await api.post('/admin/rental-file/qr-code-token/validation', data, {
      publicCapability: true
    })

    return response.data
  }

  async sendPictureWithQrCodeToken(data) {
    const response = await api.put('/admin/rental-file/send-picture-with-qr-code', data, {
      publicCapability: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }
}

export default new RentalFileService()
